<template>
    <section
        role="alert"
        class="fawry__info"
    >
        <p>
            {{ translate("ui.fawry.info", "The amount displayed is exclusive of the standard processing fee at the outlet.")}}
        </p>
    </section>
</template>
<script>
export default {
    name: "FawryInfo",
};
</script>
<style lang="scss" scoped>
.fawry__info {
  width: 100%;
  
  background: #FFFDFB;
  border: 1px solid rgba(108, 108, 108, 0.15);
  box-sizing: border-box;
  border-radius: 4px;

  padding: 14px;
  color: $black-3;

  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
}
</style>